import LocalizedStrings from 'react-localization';

let strings = new LocalizedStrings({
  en: {
    choose_your_area: 'Choose Your Area',
    search_areas: 'Search Areas ..',
    search_for_items: 'Search for items',
    orders: 'Orders',
    special_instructions: 'Special Instructions',
    ex_Without_onions: '(Optional) e.g. Without Onions..',
    add_to_basket: 'Add to Basket',
    checkout: 'Checkout',
    edit_order: 'Edit Order',
    order: 'Order',
    delivery: 'Delivery',
    total: 'Total',
    details: 'Details',
    delivery_method: 'Delivery',
    pick_up: 'Pick up',
    phone: 'Phone',
    select_mobile_no: 'Select Mobile No.',
    select_address: 'Select Address',
    add_new_phone: 'Add New Phone Number',
    street_name: 'Street Name',
    building: 'Building',
    floor: 'Floor',
    Address: 'Address',
    appartment_number: 'Appartment Number',
    directions: 'Additional Directions (Optional)',
    additional_notes: 'Additional Notes (Optional)',
    order_now: 'Order Now',
    get_free_items: 'Get free items now',
    quantity: 'Quantity',
    your_cart: 'Your Cart',
    about_us: 'About Us',
    contact: 'Contact',
    us: 'Us',
    contact_us: 'Contact Us',
    follow_us: 'Follow Us On',
    address: 'Address',
    regular_price: 'Regular Price',
    back: 'Back',
    name: 'Name',
    recent_orders: 'Recent Orders',
    currency: 'EGP',
    choose_branch: 'Choose Branch',
    fetarTime: 'Fetar Time',
    ASAP: 'as soon as possible',
    choose_order_time: 'Choose Order Time',
    choose_method: 'Choose A Method',
    past_orders: 'My Past Orders',
    address_save: 'The address will be saved !',
  },
  ar: {
    choose_your_area: 'إختر منطقتك، من فضلك',
    search_areas: 'ابحث عن منطقتك ..',
    search_for_items: 'البحث عن أصناف',
    orders: 'الطلبات',
    special_instructions: 'ملاحظة للمطعم',
    ex_Without_onions: 'اختياري) مثال: بدون بصل)',
    add_to_basket: 'أضف إلى سلة المشتريات',
    checkout: 'عرض السلة',
    edit_order: 'تعديل الطلب',
    order: 'الطلب',
    delivery: 'خدمة التوصيل',
    total: 'المبلغ الإجمالي',
    details: 'التفاصيل',
    delivery_method: 'التوصيل',
    pick_up: 'استلم من المطعم',
    phone: 'رقم الهاتف',
    select_mobile_no: 'اختر رقم هاتف',
    select_address: 'اختر العنوان',
    add_new_phone: 'أضف رقم جديد',
    street_name: 'اسم الشارع',
    building: 'المبنى',
    floor: 'الطابق',
    Address: 'العنوان',
    appartment_number: 'رقم الشقة',
    directions: 'إرشادات إضافية - اختياري',
    additional_notes: 'ملحوظات إضافية - اختياري',
    order_now: 'تنفيذ الطلب',
    get_free_items: 'احصل على سلع مجانا',
    quantity: 'الكمية',
    your_cart: 'العربة',
    about_us: 'معلومات عنا',
    contact: 'تواصل',
    us: 'معنا',
    contact_us: 'تواصل معنا',
    follow_us: 'تابعنا على',
    address: 'العنوان',
    regular_price: 'السعر',
    back: 'رجوع',
    name: 'الاسم',
    recent_orders: 'اخر الاوردرات',
    currency: 'ج.م',
    choose_branch: 'اختر الفرع',
    fetarTime: 'وقت الفطار',
    ASAP: 'فى اقرب وقت',
    choose_order_time: 'أختر وقت الطلب',
    choose_method: 'أختر طريقة التوصيل',
    past_orders: 'اخر الاوردرات',
    address_save: 'العنوان سيتم حفظه',
  },
  qrAR: {
    choose_your_area: 'إختر منطقتك، من فضلك',
    search_areas: 'ابحث عن منطقتك ..',
    search_for_items: 'البحث عن أصناف',
    orders: 'الطلبات',
    special_instructions: 'ملاحظة للمطعم',
    ex_Without_onions: 'اختياري) مثال: بدون بصل)',
    add_to_basket: 'أضف إلى سلة المشتريات',
    checkout: 'عرض السلة',
    currency: 'جنيه',
    edit_order: 'تعديل الطلب',
    order: 'الطلب',
    delivery: 'خدمة التوصيل',
    delivery_method: 'التوصيل',
    pick_up: 'استلم من المطعم',
    total: 'المبلغ الإجمالي',
    details: 'التفاصيل',
    phone: 'رقم الهاتف',
    select_mobile_no: 'اختر رقم هاتف',
    select_address: 'اختر العنوان',
    add_new_phone: 'أضف رقم جديد',
    street_name: 'اسم الشارع',
    building: 'المبنى',
    floor: 'الطابق',
    Address: 'العنوان',
    appartment_number: 'رقم الشقة',
    directions: 'إرشادات إضافية - اختياري',
    additional_notes: 'ملحوظات إضافية - اختياري',
    order_now: 'تنفيذ الطلب',
    get_free_items: 'احصل على سلع مجانا',
    quantity: 'الكمية',
    your_cart: 'العربة',
    about_us: 'معلومات عنا',
    contact: 'تواصل',
    us: 'معنا',
    contact_us: 'تواصل معنا',
    follow_us: 'تابعنا على',
    address: 'العنوان',
    regular_price: 'السعر',
    back: 'رجوع',
    name: 'الاسم',
    recent_orders: 'اخر الاوردرات',
    currency: 'ر.ق',
    choose_branch: 'اختر الفرع',
    fetarTime: 'وقت الفطار',
    ASAP: 'فى اقرب وقت',
    choose_order_time: 'أختر وقت الطلب',
    choose_method: 'أختر طريقة التوصيل',
    past_orders: 'اخر الاوردرات',
    address_save: 'العنوان سيتم حفظه',
  },
  qrEng: {
    choose_your_area: 'Choose Your Area',
    search_areas: 'Search Areas ..',
    search_for_items: 'Search for items',
    orders: 'Orders',
    special_instructions: 'Special Instructions',
    ex_Without_onions: '(Optional) e.g. Without Onions..',
    add_to_basket: 'Add to Basket',
    checkout: 'Checkout',
    edit_order: 'Edit Order',
    order: 'Order',
    delivery: 'Delivery',
    total: 'Total',
    details: 'Details',
    delivery_method: 'Delivery',
    pick_up: 'Pick up',
    phone: 'Phone',
    select_mobile_no: 'Select Mobile No.',
    select_address: 'Select Address',
    add_new_phone: 'Add New Phone Number',
    street_name: 'Street Name',
    building: 'Building',
    floor: 'Floor',
    Address: 'Address',
    appartment_number: 'Appartment Number',
    directions: 'Additional Directions (Optional)',
    additional_notes: 'Additional Notes (Optional)',
    order_now: 'Order Now',
    get_free_items: 'Get free items now',
    quantity: 'Quantity',
    your_cart: 'Your Cart',
    about_us: 'About Us',
    contact: 'Contact',
    us: 'Us',
    contact_us: 'Contact Us',
    follow_us: 'Follow Us On',
    address: 'Address',
    regular_price: 'Regular Price',
    back: 'Back',
    name: 'Name',
    recent_orders: 'Recent Orders',
    currency: 'QR',
    choose_branch: 'Choose Branch',
    fetarTime: 'وقت الفطار',
    ASAP: 'فى اقرب وقت',
    choose_order_time: 'Choose Order Time',
    choose_method: 'Choose A Method',
    past_orders: 'My Past Orders',
    address_save: 'The address will be saved !',
  },
});

export default strings;



// WEBPACK FOOTER //
// ./src/components/language/language.js